"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class CreditCard extends Parse.Object {
    constructor(attributes) {
        super('CreditCard', attributes);
    }
    get fullName() { return this.get('fullName'); }
    set fullName(value) { this.set('fullName', value); }
    get birthDate() { return this.get('birthDate'); }
    set birthDate(value) { this.set('birthDate', value); }
    get phoneNumber() { return this.get('phoneNumber'); }
    set phoneNumber(value) { this.set('phoneNumber', value); }
    get taxId() { return this.get('taxId'); }
    set taxId(value) { this.set('taxId', value); }
    get taxDocumentType() { return this.get('taxDocumentType'); }
    set taxDocumentType(value) { this.set('taxDocumentType', value); }
    get brand() { return this.get('brand'); }
    set brand(value) { this.set('brand', value); }
    get last4() { return this.get('last4'); }
    set last4(value) { this.set('last4', value); }
    get hash() { return this.get('hash'); }
    set hash(value) { this.set('hash', value); }
    get billingAddress() { return this.get('billingAddress'); }
    set billingAddress(value) { this.set('billingAddress', value); }
    get birthdate() { return this.get('birthdate'); }
    set birthdate(value) { this.set('birthdate', value); }
    set paymentGatewayData(value) { this.set('paymentGatewayData', value); }
    get paymentGatewayData() { return this.get('paymentGatewayData'); }
}
exports.CreditCard = CreditCard;
Parse.Object.registerSubclass('CreditCard', CreditCard);
//# sourceMappingURL=CreditCard.js.map